import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Stars03 = function Stars03(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M18.5 8V3m-13 18v-5M16 5.5h5m-18 13h5M6.5 2l-.7845 1.569c-.2654.5309-.3982.7964-.5755 1.0264a3 3 0 0 1-.5446.5446c-.23.1773-.4955.31-1.0265.5755L2 6.5l1.569.7845c.5309.2654.7964.3982 1.0264.5755.2042.1574.3872.3404.5446.5446.1773.23.31.4955.5755 1.0265L6.5 11l.7845-1.569c.2654-.5309.3982-.7964.5755-1.0264a3 3 0 0 1 .5446-.5446c.23-.1773.4955-.31 1.0265-.5755L11 6.5l-1.569-.7845c-.5309-.2654-.7964-.3982-1.0264-.5755a3 3 0 0 1-.5446-.5446c-.1773-.23-.31-.4955-.5755-1.0265zM17 12l-.9511 1.9022c-.2655.531-.3983.7965-.5756 1.0266a3 3 0 0 1-.5445.5445c-.2301.1773-.4956.3101-1.0265.5756L12 17l1.9023.9511c.5309.2655.7964.3983 1.0265.5756.2041.1574.3871.3404.5445.5445.1773.2301.3101.4956.5756 1.0265L17 22l.9511-1.9022c.2655-.531.3983-.7965.5756-1.0266a3 3 0 0 1 .5445-.5445c.2301-.1773.4956-.3101 1.0265-.5756L22 17l-1.9023-.9511c-.5309-.2655-.7964-.3983-1.0265-.5756a3 3 0 0 1-.5445-.5445c-.1773-.2301-.3101-.4956-.5756-1.0265z"
    })
  }));
};
export default Stars03;